import { render, staticRenderFns } from "./ChooseBookType.vue?vue&type=template&id=3f468634"
import script from "./ChooseBookType.vue?vue&type=script&lang=ts"
export * from "./ChooseBookType.vue?vue&type=script&lang=ts"
import style0 from "./ChooseBookType.vue?vue&type=style&index=0&id=3f468634&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports